import React, { useEffect, useState, useRef } from 'react'
import { InlineMath } from 'react-katex'
import { StopFilled, PlayFilled } from '@carbon/icons-react'
import AudioFileIcon from '@mui/icons-material/AudioFile'
const HeaderTileItem = (props) => {
  const {
    smartTileData,
    sourceItem,
    audioPlaying,
    onAudioClicked,
    selectedIndex,
    shuffledArray,
    isAnimation,
    animationDirection,
    isCeneterTile
  } = props

  return (
    <div
      className={
        isAnimation
          ? animationDirection !== ''
            ? animationDirection === 'top'
              ? 'tile-item-cont slideUp'
              : 'tile-item-cont slideDown'
            : 'tile-item-cont'
          : 'tile-item-cont'
      }
      style={{
        background:
          sourceItem && sourceItem.disabled
            ? '#BDBDBD'
            : smartTileData.TopTile === 'text' || '#886DFF'
      }}
    >
      {smartTileData.TopTile === 'text' ? (
        <p className='tile-label-style'>
          {sourceItem && sourceItem.defaultInput && sourceItem.defaultInput}
        </p>
      ) : smartTileData.TopTile === 'audio' ? (
        <div className='audio-tile-cont'>
          {isCeneterTile ? (
            <div
              className='audio-tile-button'
              onClick={() => {
                if (onAudioClicked) {
                  onAudioClicked()
                }
              }}
            >
              {audioPlaying ? (
                <StopFilled className='audio-button-style' />
              ) : (
                <PlayFilled className='audio-button-style' />
              )}
            </div>
          ) : (
            <div className='audio-tile-button'>
              <AudioFileIcon style={{ width: '50px', height: '50px' }} />
            </div>
          )}
          <div className='audio-tile-tag'></div>
        </div>
      ) : smartTileData.TopTile === 'inktotext' ? (
        <span className='rectangle-content-inktotext'>
          <InlineMath>
            {sourceItem && sourceItem.defaultInput && sourceItem.defaultInput}
          </InlineMath>
        </span>
      ) : (
        <img
          src={sourceItem && sourceItem.defaultInput && sourceItem.defaultInput}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: '10px'
          }}
          alt='image'
          draggable='false'
        />
      )}
    </div>
  )
}

export default HeaderTileItem
